import { commonPageSequence, hhsProgramsPage, reviewPage } from '../../../pages'
import { InspectOther } from './pages/inspect'

export const formSchema = saveComplaint => {
  // Define the Other Complaint specific pages
  const initialPages = [hhsProgramsPage()]
  const finalPages = [reviewPage(InspectOther)]

  return {
    title: 'Other Complaint Form',
    onSubmit: formValues => saveComplaint(formValues),
    pages: initialPages.concat(
      commonPageSequence({ includeVictim: false }),
      finalPages
    )
  }
}
